module.exports = __webpack_public_path__ + "static/media/upcomming_transactions.9986f124.svg";